export default __webpack_public_path__ + "static/media/filterIcon.1da8b15c.svg";